





















































import Vue from 'vue';
import { mapActions } from 'vuex';
import { size } from 'lodash';

import ZenButton from '@reciprocity/button';
import { BForm, BFormGroup, BDropdown, BDropdownItem } from 'bootstrap-vue';
import { dateDisplay } from '@/utils';
import { SamlSettings } from '@/pages/settings/authentication/types';

import TextFieldWithCopyButton from './TextFieldWithCopyButton.vue';

export default Vue.extend({
  name: 'SpSettings',
  components: {
    BForm,
    BFormGroup,
    ZenButton,
    BDropdown,
    BDropdownItem,
    TextFieldWithCopyButton,
  },
  props: {
    samlSettings: {
      type: Object as () => SamlSettings,
      default: {},
      required: true,
    },
  },
  computed: {
    spCertSize() {
      return size(this.samlSettings.spCerts);
    },
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    downloadMetadata() {
      window.open(this.samlSettings.spEntityId, '_blank');
    },
    downloadCertURL(datetime: string) {
      return `/api/v2/settings/saml/sp/cert/${encodeURIComponent(datetime)}`;
    },
    dateDisplay,
  },
});
